import type { ConfigType, Dayjs } from 'dayjs';

import { AnalyticInterval } from '~/modules/analytics/types';
import { dayjsTz } from '~/utils/dayjs';

export { getTimeDurationLabel, getFormattedByInterval } from '~/utils/analyticInterval';

/**
 * Calculates the appropriate interval based on the date range duration
 * @param startDate - The start date of the range
 * @param endDate - The end date of the range
 * @returns The appropriate AnalyticInterval value
 */
export const getAnalyticInterval = (startDate: Dayjs, endDate: Dayjs): AnalyticInterval => {
  const durationInDays = endDate.diff(startDate, 'day');

  if (durationInDays <= 3) {
    return AnalyticInterval.HOUR;
  } else if (durationInDays <= 93) {
    return AnalyticInterval.DAY;
  } else if (durationInDays <= 365) {
    return AnalyticInterval.MONTH;
  } else {
    return AnalyticInterval.MONTH; // Default for > 365 days
  }
};

export const formatDateRange = (
  start: ConfigType,
  end: ConfigType,
  format = 'MMM DD, YYYY',
): string => {
  const startDate = dayjsTz(start);
  const endDate = dayjsTz(end);

  if (startDate.isSame(endDate, 'day')) {
    return startDate.format(format);
  }

  return `${startDate.format(format)} - ${endDate.format(format)}`;
};
